/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-16T15:24:16.81
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getRentTakeLookRecordEditInit,
	getRentTakeLookRecordView
} from '@api/rentmanage/RentTakeLookRecord';

import {
listRentTakeLookHouseInit,
listRentTakeLookHouseByAuthorizations,
deleteRentTakeLookHouse
} from '@api/rentmanage/RentTakeLookHouse';

import {
listRentTakeLookEvaluateInit,
listRentTakeLookEvaluateByAuthorizations,
deleteRentTakeLookEvaluate
} from '@api/rentmanage/RentTakeLookEvaluate';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
		AdvanceQuery: cloneObj(RespCommonDef.AdvanceQuery)
	},
	actions: {
		getRentTakeLookRecordEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentTakeLookRecordEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentTakeLookRecordView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentTakeLookRecordView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
